export default __webpack_public_path__ + "static/19767-fb8ef16875080886f445f39fff0beef6.jpg";